export type CredsystemStackParamList = {
  Credsystem_Dashboard: undefined;
  Credsystem_SignIn: undefined;
  Credsystem_Invoices: {
    currentInvoiceId: number;
  };
  Credsystem_OTPValidation: {
    ddd: string;
    phone: string;
  };
  Credsystem_SAC: undefined;
  Credsystem_About: undefined;
  Credsystem_Settings: undefined;
};

export const ScreensRequiredToLogin = {
  Credsystem_Dashboard: false,
  Credsystem_SignIn: false,
  Credsystem_Invoices: false,
  Credsystem_OTPValidation: false,
  Credsystem_SAC: false,
  Credsystem_About: false,
  Credsystem_Settings: false,
};
